const modal = {
    outer_container: 'fixed top-0 right-0 bottom-0 left-0 z-50',
    inner_container: 'flex justify-end pl-64 relative h-full',
    content_container: 'relative z-10 w-full bg-white shadow',
    overlay: 'bg-black absolute inset-0 opacity-25',
    content: 'relative p-8',
    right_panel: {
        content: 'flex flex-col h-full p-6 sm:p-8 md:10 pt-16 sm:pt-16 md:pt-16 overflow-y-auto items-center',
    }
}

export default modal;